import { Chip, Grid, makeStyles, Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getAllRoutes, handleCurrentConfig, handlePresetRedux } from "../../actions/sortingMachineManagementActions";
import { getOpenCreateEditSortingMachineDialog, handleOpenCreateEditSortingMachineDialog } from "../../reducers/uiSlice";
import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
    root: {
        height: '80vh',
        width: '100%',
        '& .MuiTableCell-head': {
            color: '#707070 !important',
            borderBottom: 'none'
        },
        '& .MuiTableCell-root': {
            paddingTop: '10px !important',
            paddingBottom: '10px !important',
        }
    },
    titleStyle: {
        backgroundColor: '#292929',
        marginTop: 40,
        padding: 20,
        borderTop: '1px solid #707070',
        borderLeft: '1px solid #707070',
        borderRight: '1px solid #707070',
        height: '8vh',
        color: 'white',
        width: '100%'
    },
    tableStyle: {
        backgroundColor: '#292929',
        borderBottom: '1px solid #707070',
        borderLeft: '1px solid #707070',
        borderRight: '1px solid #707070',
        height: '70vh',
        overflowY: 'scroll',
        overflowX: 'hidden'
    },
    headStyle: {
        borderTop: '1px solid #707070'
    },
    gridStyle: {
        cursor: 'pointer',
        color: '#FF9D00',
        width: 40,
        paddingTop: 5,
        paddingBottom: 5,
        borderRadius: 4,
        border: "#FF9D00 1px solid"
    },
    presetStyle: {
        marginBottom: 20,
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        width: 'fit-content',
        padding: 5
    }
}));

function PresetDetail(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { t } = useTranslation('sortingMachineManagement');

    const dialogObj = useSelector(getOpenCreateEditSortingMachineDialog);
    const sortingMachines = useSelector(state => state.smmReducer.sortingMachines);
    const sortingConfigs = useSelector(state => state.smmReducer.sortingConfigs);
    const searchItems = useSelector(state => state.smmReducer.searchItems);

    const [currentConfigObj, setCurrentConfigObj] = useState();
    const [preset, setPreset] = useState({});
    const [presetGroup, setPresetGroup] = useState({});
    const [configs, setConfigs] = useState();

    const handleAssignNameToNumber = (res, config) => {
        const districts = res[0].districts;
        let groupByGrid = _.groupBy(config.config_items, 'grid');
        districts.filter((district) => {
            district.routes.filter((route) => {
                for (const grid in groupByGrid) {
                    groupByGrid[grid].map((config) => {
                        if (!config.sorting_name && route.route_id + '' === config.sorting_number + '') {
                            config.sorting_name = route.route_name;
                        }
                    })
                }
            })
        })
        setPresetGroup(groupByGrid);
    }

    const handlePreset = (config) => {
        const groupByWarehouse = _.groupBy(config.config_items, 'warehouse');
        for (const key in groupByWarehouse) {
            dispatch(getAllRoutes(key))
                .then((res) => {
                    handleAssignNameToNumber(res, config)
                })
        }
        setPreset(config);
        let clone = [...sortingConfigs];
        clone.map((item) => {
            item.selected = item.id === config.id;
        })
        setConfigs(clone);
    }

    const handleEditOpen = () => {
        dispatch(handleCurrentConfig(preset.id, currentConfigObj.id === preset.id));
        dispatch(handleOpenCreateEditSortingMachineDialog({
            open: true,
            type: 'EDIT'
        }))
    }

    useEffect(() => {
        if (searchItems?.machineCode && sortingMachines?.length > 0 && sortingConfigs?.length > 0) {
            const currentMachine = sortingMachines.filter((machine) =>
                machine.machine_code + '' === searchItems?.machineCode + ''
            );
            if (currentMachine?.length > 0) {
                if (currentMachine[0].current_sorting_config && sortingConfigs?.length > 0) {
                    const currentConfig = sortingConfigs.filter((config) => config.id === currentMachine[0].current_sorting_config);
                    if (currentConfig?.length > 0) {
                        setCurrentConfigObj(currentConfig[0]);
                        handlePreset(currentConfig[0])
                    } else {
                        setCurrentConfigObj({});
                        handlePreset({})
                    }
                }
            }
        } else {
            setCurrentConfigObj({});
            handlePreset({})
        }
    }, [searchItems, sortingConfigs])

    useEffect(() => {
        setConfigs(sortingConfigs);
    }, [sortingConfigs])

    useEffect(() => {
        dispatch(handlePresetRedux(preset, presetGroup));
    }, [preset, presetGroup])

    useEffect(() => {
        setConfigs([]);
    }, [])

    return (
        <Grid container className={classes.root}>
            <Grid item xs={9} container className={classes.titleStyle}>
                <Grid item xs={6} style={{ textAlign: "left", color: 'white' }}>
                    <span>{t('active_plan')}</span>
                    <span style={{ marginLeft: 10 }}>{currentConfigObj?.name}</span>
                </Grid>
                <Grid
                    item
                    xs={6}
                    style={{
                        textAlign: "right",
                        color: "#FF9D00",
                        cursor: 'pointer'
                    }}
                    onClick={handleEditOpen}
                >
                    {t('common:edit')}
                </Grid>
            </Grid>
            <Grid item xs={3} className={classes.titleStyle} style={{ backgroundColor: '#3A3A3A', color: '#707070' }}>
                {t('sorting_plan_presets')}
            </Grid>
            <Grid item xs={9} className={classes.tableStyle} style={dialogObj.type === 'CREATE' ? { borderTop: '1px solid #707070' } : { borderTop: 'none' }}>
                <Table>
                    <TableHead className={classes.headStyle}>
                        <TableRow className={classes.tableRowColor}>
                            <TableCell align="left" style={{ width: '10%' }}>{t('compt')}</TableCell>
                            <TableCell align="left">{t('assigned_routes')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            presetGroup &&
                            _.map(presetGroup, (value, key) => (
                                <TableRow style={key % 2 ? { background: "#424242" } : { background: "#303030" }}>
                                    <TableCell align="center">
                                        <div
                                            className={classes.gridStyle}
                                        >
                                            {key}
                                        </div>
                                    </TableCell>
                                    <TableCell style={{ marginRight: 5, lineHeight: '40px' }}>
                                        {
                                            value?.length > 0 &&
                                            value.map((route) => (
                                                <Chip
                                                    label={route.sorting_name || route.sorting_number}
                                                    style={{ marginRight: 5 }}
                                                />
                                            ))
                                        }
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
            </Grid>
            <Grid item xs={3} className={classes.tableStyle} style={{ backgroundColor: '#3A3A3A', paddingLeft: 24, color: 'white' }}>
                {
                    configs?.length > 0 ?
                        configs.map((config) => (
                            <div
                                style={config.selected ? {
                                    border: '#FF9D00 1px solid',
                                    borderRadius: 4,
                                    color: '#FF9D00'
                                } : {}}
                                onClick={() => handlePreset(config, currentConfigObj)}
                                className={classes.presetStyle}
                            >
                                <span>{config.name}</span>
                                {
                                    currentConfigObj?.id === config.id &&
                                    <span style={{ color: 'red', marginLeft: 5 }}>({t('common:active')})</span>
                                }
                            </div>
                        )) :
                        <div>{t("no_predefined")}</div>
                }
            </Grid>
        </Grid>
    );
}

export default PresetDetail;